import { selectEssentialFormInfos } from 'state/essential/infos/selectors';
import { getFormMetadataByFormId } from 'state/forms/metadata/selectors';
import { getProductVariation } from 'state/selectors';
import { AppState } from 'state/state.model';

export function isEssentialFormLoaded(state: AppState, tabId: string): boolean {
  if (!getFormMetadataByFormId(state, 'essential', tabId)) {
    return false;
  }
  const infos = selectEssentialFormInfos(state, tabId);
  if (!infos) {
    return false;
  }
  if (
    !getProductVariation(state, 'Essential', {
      productSubType: infos.productDescription,
      productType: infos.instrumentName,
    })
  ) {
    return false;
  }
  return true;
}
